// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { routes } from "../config/constant";

interface AppPublicRoute {
  children: ReactNode;
  checkStatus?: boolean;
}

export function PublicRoute({ children, checkStatus = true }: AppPublicRoute) {
  if (checkStatus) {
    const appStatus = localStorage.getItem("cp-app-status");
    return appStatus === "active" ? <Navigate to={routes.home} /> : <>{children}</>;
  }
  
  return <>{children}</>;
}
